import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/inter/900.css'

import { fjalekryqiLight, fjalekryqiDark, resolveInitialThemeName } from '../theme'
import inertiaLinks from '../plugins/inertiaLinks'

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: resolveInitialThemeName(),
    themes: {
      fjalekryqiLight,
      fjalekryqiDark,
    },
  },
  defaults: {
    VBtn: { rounded: 'lg', class: 'text-none font-weight-bold' },
    VCard: { rounded: 'xl' },
    VTextField: { variant: 'outlined', density: 'comfortable' },
    VTextarea: { variant: 'outlined' },
    VSelect: { variant: 'outlined', density: 'comfortable' },
    VSwitch: { color: 'primary' },
  },
})

createInertiaApp({
  pages: '../pages',

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => ({ queryStringArrayFormat: 'brackets' }),
  },

  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(vuetify)
      .use(inertiaLinks)
      .mount(el)
  },
}).catch((error) => {
  if (document.getElementById('app')) {
    throw error
  } else {
    console.error(
      'Missing Inertia root element. Ensure your layout renders the Inertia <div id="app"> root.',
    )
  }
})
